import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
// eslint-disable-next-line import/named
import { User as FirebaseUser, onAuthStateChanged } from "firebase/auth";
import { auth } from "../config/firebase";

type AuthContentType = {
  isAuthenticated: boolean;
  currentUser: FirebaseUser | null;
  userLoggedIn: boolean;
  loading: boolean;
};
export const AuthContext = createContext<AuthContentType>({
  isAuthenticated: false,
  currentUser: null,
  userLoggedIn: false,
  loading: false,
});

type AuthProviderProps = {
  children: ReactNode;
};

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [currentUser, setCurrentUser] = useState<FirebaseUser | null>(null);
  const [userLoggedIn, setUserLoggedIn] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, initializeUser);
    return unsubscribe;
  }, []);

  useEffect(() => {
    void authenticateAdmin();
  }, [currentUser]);

  async function authenticateAdmin() {
    if (!currentUser) {
      return;
    }

    const idtoken = await currentUser.getIdTokenResult();
    setIsAuthenticated(Boolean(idtoken.claims.admin));
  }

  function initializeUser(user: FirebaseUser | null) {
    if (!user) {
      console.log("SIGNED OUT");
      setCurrentUser(null);
      setUserLoggedIn(false);
    } else {
      console.log("SIGNED IN");
      setCurrentUser(user);
      setUserLoggedIn(true);
    }

    setLoading(false);
  }

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, currentUser, userLoggedIn, loading }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
